import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInformation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M21.721 36.519a2.172 2.172 0 0 1-2.446-2.219 4 4 0 0 1 .1-.816q.1-.454.163-.815l2.772-11.087H19.5l.359-1.468 6.652-1.337L22.7 34.072l.587.261 3.392-3.717.978.652-2.12 2.707a7.3 7.3 0 0 1-2.054 2.038 3.64 3.64 0 0 1-1.762.506M25.6 15.746a1.9 1.9 0 0 1-1.435-.506 1.62 1.62 0 0 1-.488-1.157 2.7 2.7 0 0 1 .1-.718 2.26 2.26 0 0 1 .832-1.3 2.46 2.46 0 0 1 1.549-.49 1.9 1.9 0 0 1 1.435.506 1.62 1.62 0 0 1 .489 1.157q0 .164-.017.36a1.3 1.3 0 0 1-.081.358 2.26 2.26 0 0 1-.832 1.3 2.47 2.47 0 0 1-1.552.49" })
});
export default SvgInformation;
